import script from "./grouped-table.vue?vue&type=script&setup=true&lang=js"
export * from "./grouped-table.vue?vue&type=script&setup=true&lang=js"

import "./grouped-table.vue?vue&type=style&index=0&id=46a4761c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a4761c"]])

export default __exports__